module.exports = __webpack_public_path__ + "media/insulation/Fiberglass-881b1bb8.svg";